import { DirectionService } from '../utils/services/direction.service';
import { MediaQueryService } from '../utils/services/media-query.service';
import { ScrollLockService } from '../utils/services/scroll-lock.service';

export const SharedScrollLockService = new ScrollLockService();
export const SharedMediaQueryService = new MediaQueryService(window);
export const SharedDirectionService = new DirectionService(document.documentElement);
